import { SubmitPreProcessingContract } from 'src/js/modules/element-settings/helpers/stage-contracts';
import saveDownloadFile from '../../../common/components/link-field/helpers/save-download-file';
import linkTypes from '../../../common/components/link-field/constants/link-types';
import fieldNames from '../../../common/components/link-field/constants/field-names';
import errorCodes from '../../../common/constants/error-codes';
import { linkFieldNames } from '../constants/field-names';
import { getLinkFieldsValues } from './get-fields-values';

const createSubmitPreProcessingLinkHandler = () => async (flowData, context) => {
  const { getFieldsValues, createStopSignal, onPersistSharedData } = context;

  const linkFieldsValues = getLinkFieldsValues(getFieldsValues);
  const linkClickAction = linkFieldsValues[linkFieldNames.LINK_CLICK_ACTION];
  const linkType = linkFieldsValues[linkFieldNames.LINK_TYPE];

  if (linkClickAction && linkType === linkTypes.DOWNLOAD) {
    const file = linkFieldsValues[linkFieldNames.DOWNLOAD_FILE]?.[0];

    if (file) {
      try {
        await onPersistSharedData();

        const customPath = linkFieldsValues[linkFieldNames.DOWNLOAD_CUSTOM_PATH_SWITCHER]
          ? linkFieldsValues[linkFieldNames.DOWNLOAD_CUSTOM_PATH]
          : undefined;

        const { path, name } = await saveDownloadFile({ file, customPath });

        return SubmitPreProcessingContract.create({
          [fieldNames.DOWNLOAD_REFERENCE]: path,
          [fieldNames.DOWNLOAD_FILE_NAME]: name,
        });
      } catch (error) {
        if (error === errorCodes.UPLOAD_FILE_CANCELED) {
          return createStopSignal();
        }

        throw error;
      }
    }
  }
};

export default createSubmitPreProcessingLinkHandler;
